/**
 * 渲染器组件管理器，缓存管理所有表单组件
 */
class WgetMgr {
  private _temp: { [prop: string]: unknown } = {};

  setWidgetById(instId: string, component: unknown) {
    this._temp[instId] = component;
  }

  getWidgetById(instId: string) {
    return this._temp[instId] || null;
  }
}

export default new WgetMgr();
